import type { ApiResponseBase, ApiResponseError } from './client.types'

/** Falls back to the HTTP status for an empty body, an HTML page or a proxy's own JSON. */
export function toResponseError(
  body: ApiResponseBase | undefined,
  status: number,
  statusText: string,
): ApiResponseError {
  return typeof body?.error?.code === 'number' ? body.error : { code: status, message: statusText }
}
